import axios from 'axios';

const testUrl = import.meta.env.VITE_API_URL;
// console.log('testUrl', testUrl)
// console.log('env -----> ', import.meta.env.VITE_NODE_ENV)

export const API = axios.create({
  baseURL: `${testUrl}`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Separate axios to prevent infinite loop on refresh
export const refreshAPI = axios.create({
  baseURL: `${testUrl}`,
  headers: {
    'Content-Type': 'application/json',
  },
});

/*
|-- index.js          # Base API setup (Axios instance)
        |-- admin.ts          # Admin-related API calls (auth for admins specifically)
        |-- identity.ts       # Authentication API calls (login, logout, refresh-token)
        |-- user.ts           # User-related API calls (create, delete, get by ID, update, etc.)
        |-- comment.ts        # Comment-related API calls (fetch-comments, get comments)
        |-- post.ts           # Post-related API calls (fetch-posts, get posts)
        |-- social.ts         # Social-related API calls (create social, set main, update access token)
*/
